"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicBoostHarnessFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "weightedAmount",
                type: "uint256",
            },
        ],
        name: "BoostMarket",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSpeed",
                type: "uint256",
            },
        ],
        name: "BorrowSpeedUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "tonicAccruedDelta",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "marketIndex",
                type: "uint256",
            },
        ],
        name: "DistributedReward",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "RemoveMarket",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "avgBoost",
                type: "uint256",
            },
        ],
        name: "SetAvgBoost",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newSpeed",
                type: "uint256",
            },
        ],
        name: "SupplySpeedUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newWeightedAmount",
                type: "uint256",
            },
        ],
        name: "UpdateAmount",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newMultiplier",
                type: "uint256",
            },
        ],
        name: "UpdateMultiplier",
        type: "event",
    },
    {
        inputs: [],
        name: "BOOST_MULTIPLIER_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "BOOST_TYPE_LENGTH",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOUBLE_PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MARKET_INITIAL_INDEX",
        outputs: [
            {
                internalType: "uint224",
                name: "",
                type: "uint224",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_BOOST_PER_USER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_BOOST_MULTIPLIER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PRECISION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "avgBoost",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "blockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "tTokens",
                type: "address[]",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType[]",
                name: "boostTypes",
                type: "uint8[]",
            },
        ],
        name: "boostMarkets",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "boostMultipliers",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "boostThresholds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "boostThresholdsCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "boostTokenBalance",
                type: "uint256",
            },
        ],
        name: "calculateBoostMultiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "multiplier",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "claimTokenHelper",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
        ],
        name: "claimTonic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
        ],
        name: "getUserBoostCollections",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
        ],
        name: "getUserInfo",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "blocks",
                type: "uint256",
            },
        ],
        name: "harnessFastForward",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ERC20",
                name: "_tonic",
                type: "address",
            },
            {
                internalType: "address",
                name: "_vaultAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_claimTokenHelper",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType",
                name: "",
                type: "uint8",
            },
        ],
        name: "marketStates",
        outputs: [
            {
                internalType: "uint224",
                name: "index",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "block",
                type: "uint32",
            },
            {
                internalType: "uint256",
                name: "totalWeightedAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "tTokens",
                type: "address[]",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType[]",
                name: "boostTypes",
                type: "uint8[]",
            },
        ],
        name: "removeBoostMarkets",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "oldTTokens",
                type: "address[]",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType[]",
                name: "oldBoostTypes",
                type: "uint8[]",
            },
            {
                internalType: "address[]",
                name: "newTTokens",
                type: "address[]",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType[]",
                name: "newBoostTypes",
                type: "uint8[]",
            },
        ],
        name: "replaceBoostMarkets",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "resetThresholdsAndMultipliers",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "resetThresholdsAndMultipliersForTesting",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_avgBoost",
                type: "uint256",
            },
        ],
        name: "setAvgBoost",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "number",
                type: "uint256",
            },
        ],
        name: "setBlockNumber",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "_paused",
                type: "bool",
            },
        ],
        name: "setPause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "tTokens",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "_supplySpeeds",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "_borrowSpeeds",
                type: "uint256[]",
            },
        ],
        name: "setSpeeds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType",
                name: "",
                type: "uint8",
            },
        ],
        name: "speeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tonic",
        outputs: [
            {
                internalType: "contract ERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicAccrued",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "holder",
                type: "address",
            },
        ],
        name: "unClaimTonic",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "tToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "enum TectonicBoostV1.BoostType",
                name: "boostType",
                type: "uint8",
            },
        ],
        name: "updateAmount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "updateMultiplier",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "userInfos",
        outputs: [
            {
                internalType: "uint256",
                name: "count",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "multiplier",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "vaultAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
class TectonicBoostHarnessFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicBoostHarnessFactory = TectonicBoostHarnessFactory;
TectonicBoostHarnessFactory.bytecode = _bytecode;
TectonicBoostHarnessFactory.abi = _abi;
//# sourceMappingURL=TectonicBoostHarnessFactory.js.map